export const generatePageTitle = ({ name, isApple }) => {
  if (!name) return "";

  return isApple
    ? `Buy ${name} & Top Deals - Save Instantly | GCX`
    : `Buy ${name} Gift Cards & Top Deals - Save Instantly | GCX`;
};

export const generatePageDescription = ({ name, metaDescription }) => {
  if (metaDescription) return metaDescription;
  if (!name) return "";

  switch (name) {
    case "Amazon":
      return `Buy Amazon gift cards online with discounts and coupon codes. Save on deals and get instant delivery. Shop GCX for the best Amazon gift card offers.`;
    case "Walmart":
      return `Buy Walmart gift cards online with discounts and promo codes. Check your Walmart gift card balance easily and save on your next purchase with GCX.`;
    case "Home Depot":
      return `Purchase Home Depot gift cards online with discounts and promo codes. Check your Home Depot gift card balance and save with GCX's trusted marketplace.`;
    case "Lowe's":
      return `Save on Lowe’s gift cards with exclusive promo codes and discounts. Buy online and enjoy great deals at GCX, your trusted gift card marketplace.`;
    case "Nike":
      return `Buy Nike gift cards online with discounts and promo codes. Check your Nike gift card balance easily and save on your next purchase at GCX.`;
    default:
      return `Buy ${name} gift cards online and instantly save an average of 10%. GCX is the smartest way to save every day. Discounts on 4,000+ brands. Guaranteed.`;
  }
};
